// i18m文件夹下新建index.js
import Vue from 'vue'
import Vuei18n from 'vue-i18n'
Vue.use(Vuei18n)
import zh from './locale/zh.json'
import cht from './locale/cht.json'

const i18n = new Vuei18n({
  locale: "cht", // 语言
  fallbackLocale: "zh", // 当没有指定语言时的回退语言
  messages: {
    zh, // 文案的中文版
    cht // 文案的繁体版
  },
  legacy: false,
  globalInjection: true,
})
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js